
import React, { useState, useEffect } from 'react'
import {
    CNav,
    CNavItem,
    CNavLink,
    CRow,
    CTabContent,
    CTabPane,
    CModal,
    CTabs,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CBadge,
    CDataTable,
    CButton,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CForm,
    CSelect,
    CFormGroup,
    CInputGroupAppend,
    CInputGroup,
    CLabel,
    CInputCheckbox,
    CSwitch,
    CFormText,
    CInput,
    CInputFile
} from '@coreui/react'
import API from '../../utils/apiCalling';
import { config } from '../../utils/apiUrl';


const PreOfferDocModal = (props) => {
    const { preOfferModalOpen, message, isPreOfferModalOpen, candidateDetails } = props
    return (
        <div className="">
            <CModal
                show={preOfferModalOpen}
                onClose={() => isPreOfferModalOpen()}
                size="xl"
            >
                <CModalHeader closeButton>
                    <CModalTitle>{message}</CModalTitle>
                </CModalHeader>
                <CModalBody>



                </CModalBody>
                <CModalFooter>
                    <CButton color="danger" onClick={() => isPreOfferModalOpen()}><i className="fa fa-times" aria-hidden="true"></i></CButton>{' '}
                </CModalFooter>
            </CModal>
        </div>

    )
}
export default PreOfferDocModal